export const commonPaths = {
  static: {
    root: '/',
    notFound: '/404',
    privacyPolicy: '/privacy-policy',
    checkShareCertificate: '/check-share-certificate',
    acknowledgementsAndDeclarations: '/acknowledgements-and-declarations',
  },
};
